<template>
  <form @submit.prevent="handleSubmit" class="marketplace-checkout--order-consent">
    <SloField>
      <SloLabel for="agree" class="flex items-start gap-sm text-lg c-gray-900">
        <SloInput
          v-model="agree"
          :checked="agree"
          id="agree"
          type="checkbox"
          name="agree"
          class="mt-xs"
        />
        <span>
          {{ 'I have read and agreed with the' | t }}
          <a href="https://legal.sloan.com/sloan-marketplace.html#terms-of-sale-sloan-marketplace-llc" target="_blank">{{ 'Terms of Sale' | t }}</a>,
          <a href="https://legal.sloan.com/#privacy-policy" target="_blank">{{ 'Privacy Policy' | t }}</a>,
          {{ 'and' | t }}
          <a href="https://legal.sloan.com/sloan-marketplace.html#terms-of-use" target="_blank">{{ 'Terms of Use' | t }}</a>
        </span>
      </SloLabel>
    </SloField>
    <div class="flex items-start justify-end mt-lg">
      <SloButton :disabled="!agree || loading" type="submit" class="fixed-button-width">
        <SloLoader :loading="loading" color="white" size="md">
          {{ 'Place Order' | t }}
        </SloLoader>
      </SloButton>
    </div>
  </form>
</template>

<script>
import {mapGetters} from 'vuex';
import t from '../../main/i18n';
import SloButton from '../../../lib/components/SloButton.vue';
import SloField from '../../../lib/components/SloField.vue';
import SloInput from '../../../lib/components/SloInput.vue';
import SloLabel from '../../../lib/components/SloLabel.vue';
import SloLoader from '../../../lib/components/SloLoader.vue';

export default {
  name: 'CheckoutStep5',
  components: {
    SloButton,
    SloField,
    SloLabel,
    SloInput,
    SloLoader
  },
  filters: {
    t
  },
  data() {
    return {
      loading: false,
      agree: false
    };
  },
  computed: {
    ...mapGetters('marketplace', ['cartHasRestrictedMessages'])
  },
  methods: {
    handleSubmit() {
      this.loading = true;

      if (this.cartHasRestrictedMessages) {
        this.$emit('restrictedMessagesModalToggle', true);
        this.loading = false;
        this.agree = false;
        return;
      }

      this.$emit('continue');
    }
  }
};
</script>

<style scoped lang="scss">
@import '../../../scss/variables';
@import '../../../scss/system';

.fixed-button-width {
  flex-basis: 112px;
}
</style>
